// VARIABLES
var prod_Url = 'https://www.masbymessi.com';
var root_Url = 'https://'+location.hostname;

const locationLanguage = (navigator.language || navigator.userLanguage).split('-')[0];
const languages = [
  {
    handle: 'en',
    traductions: {
      title: 'SELECT YOUR COUNTRY PREFERENCES',
      text_prev: "We've noticed you are visiting from",
      text_next: ". Would you like to navigate to your country-specific content?",
      btn_primary: 'UPDATE',
      btn_link: 'STAY ON '
    }
  },
  {
    handle: 'es',
    traductions: {
      title: 'SELECCIONA TUS PREFERENCIAS DE PAÍS',
      text_prev: "Hemos notado que estás visitando desde",
      text_next: ". ¿Te gustaría navegar por el contenido específico de tu país?",
      btn_primary: 'ACTUALIZAR',
      btn_link: 'QUEDARSE EN '
    }
  },
  {
    handle: 'fr',
    traductions: {
      title: 'SÉLECTIONNEZ VOS PRÉFÉRENCES DE PAYS',
      text_prev: "Nous avons remarqué que vous visitez depuis",
      text_next: ". Souhaitez-vous naviguer vers le contenu spécifique à votre pays?",
      btn_primary: 'METTRE À JOUR',
      btn_link: 'RESTER SUR '
    }
  },
  {
    handle: 'ie',
    traductions: {
      title: 'ROGHAIGH DO ROGHANNA TÍRE',
      text_prev: "Táimid tar éis a thabhairt faoi deara go bhfuil tú ag tabhairt cuairte ón",
      text_next: ". Ar mhaith leat dul chuig an ábhar atá sonrach do do thír?",
      btn_primary: 'NUA-AIRIÚ',
      btn_link: 'FAN AR '
    }
  }
];
let userPageInSameCountry;

// const url = 'https://ipapi.co/json/';

// FUNCTIONS
function visitedSite() {
  const actualCountry = root_Url;
  const storeName = storeOptions.find(option => option.url === actualCountry);
  if ( window.location.href.includes('/fr-ca') || window.location.href.includes('/en-ca') ) {
    return 'CANADA';
  } else if ( window.location.href.includes('/en-ie') ) {
    return 'IRELAND';
  }
  return storeName.name;
}

function getCookie(name) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  for(let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

function setCookie(cookieName, value, expirationDays) {
  const isDevDomain = location.hostname.includes('-dev');
  const newDate = new Date();
  newDate.setTime(newDate.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
  const expires = "expires=" + newDate.toUTCString();
  const path = "path=/";

  if (isDevDomain) {
    document.cookie = `${cookieName}=${value}; ${expires}; ${path};`;
  } else {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; ${path};`;
    document.cookie = `${cookieName}=${value}; ${expires}; ${path}; domain=.masbymessi.com; secure; samesite=Lax`;
  }
}


function redirectStore(selectedOption) {
  const pathSelectedStore = storeOptions.find(option => option.handle === selectedOption);
  const browserLanguage = navigator.language.split('-')[0];

  if( pathSelectedStore.handle == 'ca' ){ 
    if (browserLanguage === 'fr') {
      this.setCookie("country_redirect_handle", `${ pathSelectedStore.url }`, 182);
      this.setCookie("country_slug_handle", `/fr-ca/`, 182);
      window.location.href = `${ pathSelectedStore.url }/fr-ca?redirect=true`;
    } else {
      this.setCookie("country_redirect_handle",`${ pathSelectedStore.url }` , 182);
      this.setCookie("country_slug_handle", `/en-ca/`, 182);
      window.location.href = `${ pathSelectedStore.url }/en-ca?redirect=true`;
    }
  }
  else if (pathSelectedStore.handle == 'ie' ) {
    this.setCookie("country_redirect_handle",`${ pathSelectedStore.url }` , 182);
    this.setCookie("country_slug_handle", `/en-ie/`, 182);
    window.location.href = `${ pathSelectedStore.url }?redirect=true`;
  }
  else if (pathSelectedStore.handle == 'us' ) {
    if (browserLanguage === 'es') {
      this.setCookie("country_redirect_handle",`${ pathSelectedStore.url }` , 182);
      this.setCookie("country_slug_handle", `/es/`, 182);
      window.location.href = `${ pathSelectedStore.url }/es?redirect=true`;
    } else {
      this.setCookie("country_redirect_handle",`${ pathSelectedStore.url }` , 182);
      this.setCookie("country_slug_handle", `/`, 182);
      window.location.href = `${ pathSelectedStore.url }?redirect=true`;
    }
  }
  else{
    this.setCookie("country_redirect_handle",`${ pathSelectedStore.url }` , 182);
    this.setCookie("country_slug_handle", `/`, 182);
    window.location.href = `${ pathSelectedStore.url }?redirect=true`;
  }
}

function initModal(userCountry) {
  if (userCountry != current_iso_code) {
    document.querySelector('#nova-country-language-switcher').classList.add('show-modal');
    document.querySelector('#nova-country-language-switcher').querySelector('.modal--close').addEventListener('click', () => {
      document.querySelector('#nova-country-language-switcher').classList.remove('show-modal');
    });
    document.querySelector('#nova-country-language-switcher').querySelector('.modal--btn-primary').addEventListener('click', () => {
      const selectedOption = document.querySelector('#country-language').value;
      setCookie("country_language", selectedOption, 182);
      redirectStore(selectedOption);
    });

    // Pre-select language based on browser language
    const selectInput = document.querySelector('#country-language');
    const browserLanguage = navigator.language.split('-')[0];
    const findLanguage = languages.find(language => language.handle === browserLanguage);
    
    if (findLanguage) {
      document.querySelector('.traductions-title').innerText = findLanguage.traductions.title;
      document.querySelector('.traductions-text_prev').innerText = findLanguage.traductions.text_prev;
      document.querySelector('.traductions-text_next').innerText = findLanguage.traductions.text_next;
      document.querySelector('.traductions-btn_primary').innerText = findLanguage.traductions.btn_primary;
      document.querySelector('.traductions-btn_link').innerText = findLanguage.traductions.btn_link;
    }

    storeOptions.forEach((option) => {
      const optionElement = document.createElement('option');
      optionElement.value = option.handle;
      if (browserLanguage === 'en') {
        optionElement.text = option.name;
      } else if (browserLanguage === 'es') {
        optionElement.text = option.name_es;
      } else if (browserLanguage === 'fr') {
        optionElement.text = option.name_fr;
      } else {
        optionElement.text = option.name_en;
      }
      if (option.handle === userCountry) {
        optionElement.selected = true;
      }
      selectInput.appendChild(optionElement);
    });
  }
}

function validateCookie() {
  const cookieCountryLanguage = this.getCookie("country_language");
  if (cookieCountryLanguage) {
    ipapiValue = '';
  } else {
    fetch(url, {
      Authorization: ipapiValue
    })
    .then(function(response) {
      response.json().then(jsonData => {
        userCountry = jsonData.country_code.toLowerCase();
        if ( userCountry != null ){
          document.querySelector('#nova-country-language-switcher').querySelector('.actual-country').innerText = jsonData.country_name;
          document.querySelector('#nova-country-language-switcher').querySelector('.actual-store').innerText = visitedSite();
    
          document.querySelector('#nova-country-language-switcher').querySelector('.modal--btn-link').addEventListener('click', () => {
            const defaultOption = current_iso_code;
            this.setCookie("country_language", defaultOption, 182);
            this.setCookie("country_redirect_handle", `${ window.location.origin }`, 182);
            this.setCookie("country_slug_handle", `${ Shopify.routes.root }`, 182);
            document.querySelector('#nova-country-language-switcher').classList.remove('show-modal');
          });
          initModal(userCountry);
        }
      });
    })
    .catch(function(error) {
      console.error(error);
    })
    .finally(function() {
      ipapiValue = '';
    });
  }
}

function initCountryLanguageSwitcher() {
  validateCookie();
}

// CALLS
initCountryLanguageSwitcher();
